import { render, staticRenderFns } from "./QSummitHomePageFooterTrees.vue?vue&type=template&id=f152efde&"
var script = {}
import style0 from "./QSummitHomePageFooterTrees.vue?vue&type=style&index=0&id=f152efde&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports